import React from 'react';
import type { DivElementProps } from '../common-types';

interface DividerProps extends DivElementProps {
  text: string;
}

export function Divider(props: Readonly<DividerProps>): React.JSX.Element {
  const { text, ...divProps } = props;
  return (
    <div className="ehs-divider" {...divProps}>
      {text}
    </div>
  );
}
